import { useTranslation } from 'react-i18next'
import { ContentLayout } from 'components/Layouts'
import { MsaDisclaimer } from 'containers/Claims/components/MsaDisclaimer'
import { BreadCrumb } from 'components/BreadCrumb/BreadCrumb'
import { buildAbsoluteMedicareMyUrl } from 'utils/urls/buildAbsoluteMedicareMyUrl'

const MsaDefaultBreadcrumb = () => {
  const { t } = useTranslation('msa')
  return (
      <BreadCrumb
        backButtonText={t('navigation.backToMyClaims')}
        backButtonLink="/claims"
        navAriaLabel={t('navigation.backToClaimsMainPageAriaLabelMSA')}
        width="wide"
        siteActivityProps={{
          core: {
            component: 'Claims',
            coreClickData: {
              linkText: t('navigation.backToMyClaims'),
              linkUrl: buildAbsoluteMedicareMyUrl('/claims')
            },
            elementId: 'msa_backtosearch_click'
          }
        }}
      />
  )
}

type MsaDisclaimerPageProps = {
  onAccept: () => void
}
export const MsaDisclaimerPage = ({ onAccept }: MsaDisclaimerPageProps) => {
  const { t } = useTranslation('msa')

  return (
    <>
      <MsaDefaultBreadcrumb />
      <ContentLayout
        className="ds-u-padding-bottom--7"
        width="wide"
        heading={t('summary.heading')}
        withPrintButton
      >
        <div className="ds-l-container my-c-Msa">
          <MsaDisclaimer onAccept={onAccept} />
        </div>
      </ContentLayout>
    </>
  )
}
